<script lang="ts">
  let { sizeClass = 'w-full h-full', color }: { sizeClass?: string; color?: 'black' | 'default' } =
    $props();
</script>

<svg
  viewBox="0 0 96 96"
  version="1.1"
  class={sizeClass}
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
>
  {#if color === 'black'}
    <defs>
      <clipPath id="cut-off-half">
        <rect x="0" y="0" width="48" height="96" />
      </clipPath>
    </defs>
  {/if}
  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" clip-path="url(#cut-off-half)">
    <g>
      <g>
        <g fill-rule="nonzero">
          <rect
            fill={color === 'black' ? 'transparent' : '#DCDCE6'}
            x="48"
            y="0"
            width="48"
            height="96"
          />
          <rect
            fill={color === 'black' ? 'transparent' : '#00B67A'}
            x="0"
            y="0"
            width="48"
            height="96"
          />
        </g>
        <path
          d="M48,64.7 L62.6,61 L68.7,79.8 L48,64.7 Z M81.6,40.4 L55.9,40.4 L48,16.2 L40.1,40.4 L14.4,40.4 L35.2,55.4 L27.3,79.6 L48.1,64.6 L60.9,55.4 L81.6,40.4 L81.6,40.4 L81.6,40.4 L81.6,40.4 Z"
          fill={color === 'black' ? '#000' : '#FFFFFF'}
          fill-rule="nonzero"
        />
      </g>
    </g>
  </g>
</svg>
